import type { TransferAstRelayResponse } from 'features/call/call-base/interfaces';

export enum AstSignMailHandoffStatus {
  INACTIVE = 'inactive',
  SHOWING = 'showing',
  TRANSFERRING = 'transferring',
  COMPLETE = 'complete',
}

export interface AstSignMailState {
  handoffStatus: AstSignMailHandoffStatus;
  hasHandoffSucceeded: boolean;
  isQueueReturnNoticeVisible: boolean;
  astSignMailMode: number | undefined;
  textOnSignMail: string;
  transferAstRelayResponse: TransferAstRelayResponse | null;
}
